import React from 'react';
import CaseStudyTemplate, {
  CaseStudySection,
  GraphicPlaceholder,
  StoryParagraph,
} from './CaseStudyTemplate';

const WayfairCaseStudy = () => {
  return (
    <CaseStudyTemplate
      title="Reimagining project workflows for Wayfair Professional"
      intro="I redesigned a fragmented project-management experience into a clearer command center so account managers and business customers could track orders, milestones, and decisions without jumping across tools."
      details={[
        { label: 'Role', value: 'Product Design Intern' },
        { label: 'Timeline', value: '3 months' },
        { label: 'Platform', value: 'Wayfair Professional' },
        { label: 'Mentorship', value: 'Jim Coleman, Prashant Iyer' },
      ]}
      sectionNav={[
        { id: 'overview', label: 'Overview' },
        { id: 'architecture', label: 'Architecture' },
        { id: 'features', label: 'Features' },
        { id: 'notes', label: 'Notes' },
      ]}
      heroImageSrc="/wayfair-professional.png"
      heroImageAlt="Wayfair Professional delivery tracking interface"
      backTarget="selected-work"
    >
      <CaseStudySection id="overview" title="Overview">
        <StoryParagraph>
          B2B teams were managing project timelines with too many disconnected screens. Basic questions like "Where is this order?" or "What should happen next?" required digging through multiple tabs.
        </StoryParagraph>
        <StoryParagraph>
          The design goal was to reduce coordination friction and help teams focus on customer outcomes rather than interface overhead.
        </StoryParagraph>
      </CaseStudySection>
      <CaseStudySection id="architecture" title="Architecture">
        <StoryParagraph>
          I mapped the end-to-end project journey and reorganized it around one central rhythm: status, milestones, and next actions. The information architecture shifted from static lists to timeline-first planning.
        </StoryParagraph>
        <GraphicPlaceholder
          title="Graphic placeholder: journey and IA map"
          note="Show previous five-tool workflow beside the consolidated dashboard architecture."
        />
      </CaseStudySection>
      <CaseStudySection id="features" title="Features">
        <StoryParagraph>
          The final design introduced a calendar-based delivery view and milestone planning for installations, making project risk visible earlier and helping teams coordinate proactively.
        </StoryParagraph>
      </CaseStudySection>
      <CaseStudySection id="notes" title="Notes">
        <StoryParagraph>
          This project taught me to identify root workflow problems before polishing UI details. The strongest improvements came from reframing the core task model, not adding more screens.
        </StoryParagraph>
      </CaseStudySection>
    </CaseStudyTemplate>
  );
};

export default WayfairCaseStudy; 